<template>
  <div class="app-container">
    <!-- 搜索 -->
    <el-form :inline="true" :model="queryParams" class="search-form">
      <el-form-item label="任务名称">
        <el-input v-model="queryParams.taskname" placeholder="请输入任务名称" clearable />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleQuery">查询</el-button>
        <el-button type="success" @click="handleAdd">新增任务</el-button>
      </el-form-item>
    </el-form>

    <!-- 任务列表 -->
    <el-table :data="taskList" border style="width: 100%">
      <el-table-column prop="taskname" label="任务名称" />
      <el-table-column prop="wechatid" label="企业微信ID" />
      <el-table-column prop="roomid" label="房间号ID" width="120" />
      <el-table-column prop="end_broad_cast_time" label="完播时长(秒)" width="140" />
      <el-table-column prop="arrival_label" label="到课标签" />
      <el-table-column prop="end_broad_cast_label" label="完播标签" />
      <el-table-column prop="zhuliu_time" label="驻留/驻留时长(秒)" width="140" />
      <el-table-column prop="zhuliu_label" label="驻留标签" />
      <el-table-column prop="task_statu" label="任务状态" width="110">
        <template slot-scope="{ row }">
          <el-tag :type="row.task_statu === 1 ? 'success' : 'danger'">
            {{ row.task_statu === 1 ? '启用' : '停用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="监控状态" width="120">
        <template slot-scope="{ row }">
          <el-tag type="info">{{ row.statusMessage ? row.statusMessage : '未校验' }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="操作" fixed="right" width="300">
        <template slot-scope="{ row }">
          <el-button size="small" type="primary" @click="handleEdit(row)">编辑</el-button>
          <el-button size="small" type="info" @click="showDataDialog(row)">查看数据</el-button>
          <el-button size="small" type="danger" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      v-model:current-page="queryParams.pageNum"
      v-model:page-size="queryParams.pageSize"
      :total="total"
      layout="total, prev, pager, next, jumper"
      @current-change="handlePageChange"
    />

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%">
      <el-form ref="taskForm" :model="taskForm" :rules="rules" label-width="140px">
        <el-form-item label="任务名称" prop="taskname">
          <el-input v-model="taskForm.taskname" placeholder="请输入任务名称" />
        </el-form-item>
        <el-form-item label="企业微信ID" prop="wechatid">
          <el-input v-model="taskForm.wechatid" placeholder="请输入企业微信ID" />
        </el-form-item>
        <el-form-item label="平台Token" prop="openapitoken">
          <el-input v-model="taskForm.openapitoken" placeholder="请输入平台Token" />
        </el-form-item>
        <el-form-item label="房间号ID" prop="roomid">
          <el-input v-model.number="taskForm.roomid" placeholder="请输入房间号ID" />
        </el-form-item>
        <el-form-item label="完播时长(秒)" prop="end_broad_cast_time">
          <el-input v-model.number="taskForm.end_broad_cast_time" placeholder="请输入完播阈值(秒)" />
        </el-form-item>
        <el-form-item label="到课标签" prop="arrival_label">
          <el-input v-model="taskForm.arrival_label" placeholder="请输入到课标签" />
        </el-form-item>
        <el-form-item label="完播标签" prop="end_broad_cast_label">
          <el-input v-model="taskForm.end_broad_cast_label" placeholder="请输入完播标签" />
        </el-form-item>
        <el-form-item label="驻留/驻留时长(秒)" prop="zhuliu_time">
          <el-input v-model.number="taskForm.zhuliu_time" placeholder="请输入驻留阈值(秒)" />
        </el-form-item>
        <el-form-item label="驻留标签" prop="zhuliu_label">
          <el-input v-model="taskForm.zhuliu_label" placeholder="请输入驻留标签" />
        </el-form-item>
        <el-form-item label="任务状态" prop="task_statu">
          <el-radio-group v-model="taskForm.task_statu">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </span>
    </el-dialog>

    <!-- 查看数据对话框 -->
    <el-dialog title="任务数据" :visible.sync="dataDialogVisible" width="85%">
      <el-form :inline="true" :model="dataQueryParams" class="search-form">
        <el-form-item label="用户名">
          <el-input v-model="dataQueryParams.wechat_user_name" placeholder="用户名" clearable />
        </el-form-item>
        <el-form-item label="到播状态">
          <el-select v-model="dataQueryParams.dk_statu" placeholder="请选择" clearable>
            <el-option label="成功" :value="1" />
            <el-option label="失败" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="完播状态">
          <el-select v-model="dataQueryParams.wb_statu" placeholder="请选择" clearable>
            <el-option label="成功" :value="1" />
            <el-option label="失败" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="驻留状态">
          <el-select v-model="dataQueryParams.zhuliu_statu" placeholder="请选择" clearable>
            <el-option label="成功" :value="1" />
            <el-option label="失败" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="日期范围">
          <el-date-picker
            v-model="dataQueryParams.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchTaskData">查询</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="taskDataList" border style="width: 100%" v-if="taskDataList && taskDataList.length >= 0">
        <el-table-column prop="fgId" label="用户ID" width="150" />
        <el-table-column prop="roomid" label="房间号" width="100" />
        <el-table-column prop="nickName" label="用户名" width="160" />
        <el-table-column prop="clientavatar" label="头像" width="100">
          <template slot-scope="{ row }">
            <el-image style="width:50px;height:50px" :src="row.clientavatar" fit="cover" />
          </template>
        </el-table-column>
        <el-table-column prop="studyDurationSeconds" label="学习时长(秒)" width="140" />
        <el-table-column prop="dk_statu" label="到课状态" width="100">
          <template slot-scope="{ row }">
            <el-tag :type="row.dk_statu === 1 ? 'success' : 'danger'">{{ row.dk_statu === 1 ? '成功' : '失败' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="wb_statu" label="完播状态" width="100">
          <template slot-scope="{ row }">
            <el-tag :type="row.wb_statu === 1 ? 'success' : 'danger'">{{ row.wb_statu === 1 ? '成功' : '失败' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="zhuliu_statu" label="驻留状态" width="100">
          <template slot-scope="{ row }">
            <el-tag :type="row.zhuliu_statu === 1 ? 'success' : 'danger'">{{ row.zhuliu_statu === 1 ? '成功' : '失败' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="query_date" label="数据日期" width="120" />
        <el-table-column label="上报日志" width="150">
          <template slot-scope="{ row }">
            <el-button type="text" @click="showMessageDialog(row)">查看日志</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        v-model:current-page="dataQueryParams.pageNum"
        v-model:page-size="dataQueryParams.pageSize"
        :total="dataTotal"
        layout="total, prev, pager, next, jumper"
        @current-change="handleDataPageChange"
      />
    </el-dialog>

    <!-- 日志详情 -->
    <el-dialog title="上报日志详情" :visible.sync="messageDialogVisible" width="50%">
      <el-descriptions :column="1" border>
        <el-descriptions-item label="到课信息">{{ currentMessage.dk_message ? currentMessage.dk_message : '无' }}</el-descriptions-item>
        <el-descriptions-item label="完播信息">{{ currentMessage.wb_message ? currentMessage.wb_message : '无' }}</el-descriptions-item>
        <el-descriptions-item label="驻留信息">{{ currentMessage.zhuliu_message ? currentMessage.zhuliu_message : '无' }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      queryParams: {
        taskname: "",
        pageNum: 1,
        pageSize: 10,
        uid: null
      },
      taskList: [],
      total: 0,

      dialogVisible: false,
      dialogTitle: "",
      taskForm: {
        id: null,
        taskname: "",
        wechatid: "",
        openapitoken: "",
        roomid: null,
        end_broad_cast_time: 0,
        arrival_label: "",
        end_broad_cast_label: "",
        zhuliu_time: 0,
        zhuliu_label: "",
        task_statu: 1,
        uid: ""
      },
      rules: {
        taskname: [{ required: true, message: "请输入任务名称", trigger: "blur" }],
        wechatid: [{ required: true, message: "请输入企业微信ID", trigger: "blur" }],
        openapitoken: [{ required: true, message: "请输入平台Token", trigger: "blur" }],
        roomid: [{ required: true, message: "请输入房间号ID", trigger: "blur" }],
        end_broad_cast_time: [{ required: true, message: "请输入完播时长", trigger: "blur" }],
        arrival_label: [{ required: true, message: "请输入到课标签", trigger: "blur" }],
        end_broad_cast_label: [{ required: true, message: "请输入完播标签", trigger: "blur" }],
        zhuliu_time: [{ required: true, message: "请输入驻留时长", trigger: "blur" }],
        zhuliu_label: [{ required: true, message: "请输入驻留标签", trigger: "blur" }]
      },

      // 数据查看
      dataDialogVisible: false,
      currentTaskId: null,
      taskDataList: [],
      dataTotal: 0,
      dataQueryParams: {
        wechat_user_name: "",
        dk_statu: null,
        wb_statu: null,
        zhuliu_statu: null,
        dateRange: [new Date().toISOString().split("T")[0]],
        pageNum: 1,
        pageSize: 10
      },

      // 日志
      messageDialogVisible: false,
      currentMessage: {
        dk_message: "",
        wb_message: "",
        zhuliu_message: ""
      },

      userId: null
    };
  },

  created() {
    // 从路由或其他地方拿到用户 uid
    if (this.$route && this.$route.query && this.$route.query.userId) {
      this.queryParams.uid = this.$route.query.userId;
      this.userId = this.$route.query.userId;
    }

    if (!this.queryParams.uid) {
      this.$message.warning("您得先登录");
      setTimeout(function () {
        window.location.href = "https://control.zjwec.cn/page/end/login.html";
      }, 1500);
    } else {
      this.fetchTaskList();
    }
  },

  methods: {
    // 获取任务列表
    async fetchTaskList() {
      try {
        var resp = await axios.get("https://control.zjwec.cn/jfmonitorNew/task/page", {
          params: this.queryParams
        });
        if (resp && resp.data && resp.data.data) {
          this.taskList = resp.data.data.records || [];
          this.total = resp.data.data.total || 0;


          const checkPromises = this.taskList.map(task =>
            this.checkTaskStatus(task).catch(() => ({ ...task, isValid: false }))
          );

          this.taskList = await Promise.all(checkPromises);


        } else {
          this.taskList = [];
          this.total = 0;
        }
      } catch (err) {
        console.error("fetchTaskList error:", err);
        this.$message.error("获取任务失败");
      }
    },
    async checkTaskStatus(task) {
      try {
        const res = await axios.post(`https://control.zjwec.cn/jfmonitorNew/task/test`, task);

        const code = res && res.data ? res.data.code : null;

        if (code === "0") {
          return {
            ...task,
            statusMessage: '校验成功'
          };
        }  else {
          return {
            ...task,
            statusMessage: '未知错误'
          };
        }
      } catch (error) {
        console.error('任务校验异常:', error);
        return {
          ...task,
          statusMessage: '请求失败'
        };
      }
    },

    // 查询按钮
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.fetchTaskList();
    },

    // 翻页
    handlePageChange(page) {
      this.queryParams.pageNum = page;
      this.fetchTaskList();
    },

    // 新增
    handleAdd() {
      this.dialogTitle = "新增任务";
      this.dialogVisible = true;
      this.resetTaskForm();
      // 清除校验
      if (this.$refs.taskForm) {
        this.$refs.taskForm.clearValidate();
      }
    },

    // 编辑
    handleEdit(row) {
      this.dialogTitle = "编辑任务";
      this.dialogVisible = true;
      // 直接覆盖
      this.taskForm = {
        id: row.id,
        taskname: row.taskname ? row.taskname : "",
        wechatid: row.wechatid ? row.wechatid : "",
        openapitoken: row.openapitoken ? row.openapitoken : "",
        roomid: row.roomid ? row.roomid : null,
        end_broad_cast_time: row.end_broad_cast_time ? row.end_broad_cast_time : 0,
        arrival_label: row.arrival_label ? row.arrival_label : "",
        end_broad_cast_label: row.end_broad_cast_label ? row.end_broad_cast_label : "",
        zhuliu_time: row.zhuliu_time ? row.zhuliu_time : 0,
        zhuliu_label: row.zhuliu_label ? row.zhuliu_label : "",
        task_statu: row.task_statu != null ? row.task_statu : 1,
        uid: row.uid ? row.uid : this.queryParams.uid
      };
      if (this.$refs.taskForm) {
        this.$refs.taskForm.clearValidate();
      }
    },

    resetTaskForm() {
      this.taskForm = {
        id: null,
        taskname: "",
        wechatid: "",
        openapitoken: "",
        roomid: null,
        end_broad_cast_time: 0,
        arrival_label: "",
        end_broad_cast_label: "",
        zhuliu_time: 0,
        zhuliu_label: "",
        task_statu: 1,
        uid: this.queryParams.uid
      };
    },

    // 表单校验包装成 Promise
    validateForm() {
      var that = this;
      return new Promise(function (resolve, reject) {
        if (!that.$refs.taskForm) {
          // 没有 ref，直接通过
          resolve(true);
          return;
        }
        that.$refs.taskForm.validate(function (valid) {
          if (valid) resolve(true);
          else reject(false);
        });
      });
    },

    // 提交表单（新增 / 编辑）
    async submitForm() {
      try {
        await this.validateForm();
      } catch (e) {
        // 校验失败
        this.$message.error("请按表单提示修改后提交");
        return;
      }

      try {
        if (this.taskForm.id) {
          // 编辑
          var putResp = await axios.put("https://control.zjwec.cn/jfmonitorNew/task/update", this.taskForm);
          this.$message.success("修改成功");
        } else {
          // 新增
          var postResp = await axios.post("https://control.zjwec.cn/jfmonitorNew/task/add", this.taskForm);
          this.$message.success("新增成功");
        }
        this.dialogVisible = false;
        this.fetchTaskList();
      } catch (err) {
        console.error("submitForm error:", err);
        this.$message.error("操作失败");
      }
    },

    // 删除（带确认）
    handleDelete(row) {
      var that = this;
      this.$confirm("确定删除该任务吗？删除后无法恢复！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async function () {
          try {
            await axios.delete("https://control.zjwec.cn/jfmonitorNew/task/delete/" + row.id);
            that.$message.success("删除成功");
            that.fetchTaskList();
          } catch (err) {
            console.error("删除失败:", err);
            that.$message.error("删除失败");
          }
        })
        .catch(function () {
          // 取消什么也不做
        });
    },

    // ------- 数据查看相关 -------
    // 显示数据对话框（点击“查看数据”）
    showDataDialog(row) {
      this.currentTaskId = row.roomid;
      this.dataQueryParams.pageNum = 1;
      // 默认日期范围：当天（如果 dateRange 为空）
      if (!this.dataQueryParams.dateRange || this.dataQueryParams.dateRange.length === 0) {
        this.dataQueryParams.dateRange = [this.formatDate(new Date())];
      }
      this.dataDialogVisible = true;
      this.fetchTaskData();
    },

    // 读取任务数据（分页、过滤）
    async fetchTaskData() {
      if (!this.currentTaskId) {
        this.$message.warning("房间号为空，无法查询");
        return;
      }
      try {
        var params = {
          roomid: this.currentTaskId,
          wechat_user_name: this.dataQueryParams.wechat_user_name,
          dk_statu: this.dataQueryParams.dk_statu,
          wb_statu: this.dataQueryParams.wb_statu,
          zhuliu_statu: this.dataQueryParams.zhuliu_statu,
          pageNum: this.dataQueryParams.pageNum,
          pageSize: this.dataQueryParams.pageSize,
          uid: this.queryParams.uid
        };

        // 处理日期范围（如果有两个元素）
        if (this.dataQueryParams.dateRange && this.dataQueryParams.dateRange.length === 2) {
          params.queryBegin = this.dataQueryParams.dateRange[0];
          params.queryEnd = this.dataQueryParams.dateRange[1];
        } else if (this.dataQueryParams.dateRange && this.dataQueryParams.dateRange.length === 1) {
          // 单值当成当天
          params.queryBegin = this.dataQueryParams.dateRange[0];
          params.queryEnd = this.dataQueryParams.dateRange[0];
        } else {
          // 默认当天
          var today = this.formatDate(new Date());
          params.queryBegin = today;
          params.queryEnd = today;
        }

        var resp = await axios.get("https://control.zjwec.cn/jfmonitorNew/data/page", {
          params: params
        });

        if (resp && resp.data && resp.data.data) {
          this.taskDataList = resp.data.data.records || [];
          this.dataTotal = resp.data.data.total || 0;
        } else {
          this.taskDataList = [];
          this.dataTotal = 0;
        }
      } catch (err) {
        console.error("fetchTaskData error:", err);
        this.$message.error("获取任务数据失败");
      }
    },

    handleDataPageChange(page) {
      this.dataQueryParams.pageNum = page;
      this.fetchTaskData();
    },

    // 查看日志
    showMessageDialog(row) {
      this.currentMessage.dk_message = row.dk_message ? row.dk_message : "";
      this.currentMessage.wb_message = row.wb_message ? row.wb_message : "";
      this.currentMessage.zhuliu_message = row.zhuliu_message ? row.zhuliu_message : "";
      this.messageDialogVisible = true;
    },

    // 简单格式化日期 yyyy-MM-dd
    formatDate(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, "0");
      var day = String(date.getDate()).padStart(2, "0");
      return year + "-" + month + "-" + day;
    }
  }
};
</script>

<style scoped>
.app-container {
  padding: 20px;
}
.search-form {
  margin-bottom: 20px;
}
.el-pagination {
  margin-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/feedbackManager/qffeedbackmanager.vue